module.exports = __webpack_public_path__ + "img/planetEarth_c.9a8a7a75.svg";